/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

import { TextField } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';

const OptionWrapper = styled.div`
  background-color: ${(props) =>
    props.editState ? '#F1F6FF' : props.selected ? '#0B0114' : 'transparent'};
  border-radius: 3px;
  color: ${(props) =>
    props.editState ? '#000' : props.selected ? '#fff' : '#000'};
  cursor: pointer;
  min-width: 352px;
  padding: 5px 8px;
  &:hover {
    background-color: ${(props) =>
      props.selected && !props.editState ? '#0B0114' : '#F1F6FF'};
    .edit-icon,
    .delete-icon {
      display: block;
    }
  }
  &.focused {
    background-color: ${(props) =>
      props.selected && !props.editState ? '#0B0114' : '#F1F6FF'};
    outline: none;
    border: none;
  }
  .label {
    line-height: 33px;
  }
  .Superops-TextField__Input {
    background-color: #f1f6ff;
  }
  .edit-icon,
  .delete-icon {
    display: none;
  }
`;

const EditAndDeleteOption = ({
  option,
  updateOptions,
  selectOption,
  isSelected,
  isEdit,
  isDelete,
  focus,
  setFocus,
  focusElementAfterEdit,
  index
}) => {
  const [editedValue, setEditedValue] = useState(option.label);
  const ref = useRef();
  const iconColor = isSelected && !option.editState ? '#fff' : '#000';

  useEffect(() => {
    if (focus)
      if (ref.current)
        ref.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [focus]);

  useEffect(
    () => () => {
      if (option.editState) updateOptions(option, false, 'editState');
    },
    []
  );

  const onOptionChange = (text) => {
    setEditedValue(text);
  };

  const onOptionChangeBlur = () => {
    const optionValue = editedValue.trim();
    if (optionValue) {
      setEditedValue(optionValue);
    } else {
      setEditedValue(option.label);
    }
  };

  const toggleEditState = () =>
    updateOptions(option, !option.editState, 'editState');

  const enableEditState = () => {
    toggleEditState();
    setEditedValue(option.label);
  };

  const deleteOption = () => {
    updateOptions(option, null, 'delete');
    focusElementAfterEdit();
  };

  const editOption = () => {
    if (editedValue.trim()) updateOptions(option, editedValue, 'edit');
    toggleEditState();
    focusElementAfterEdit();
  };

  const cancelEdit = () => {
    setEditedValue(option.label);
    toggleEditState();
    focusElementAfterEdit();
  };

  const selectThis = () => {
    selectOption(option);
    setFocus(index);
  };

  const handleEnterKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.stopPropagation();
      onOptionChangeBlur();
      if (editedValue.trim()) editOption();
    }
  };

  return (
    <OptionWrapper
      className={`flex center jspbtwn ${focus ? 'focused' : ''}`}
      selected={isSelected}
      editState={option.editState}
      superid="CCD-option"
      ref={ref}
    >
      {option.editState ? (
        <div className="f11 mr8" onKeyDown={handleEnterKeyPress}>
          <TextField
            value={editedValue}
            onChange={onOptionChange}
            onBlur={onOptionChangeBlur}
            autoComplete="off"
            noborder
            focused
          />
        </div>
      ) : (
        <span className="label f11 mr8" onClick={selectThis}>
          {option.label}
        </span>
      )}
      <span className="flex center">
        {!option.editState && (
          <>
            {isEdit && (
              <span
                className="mr8 flex center jcenter edit-icon"
                onClick={enableEditState}
              >
                <SVGIcon name="Edit" color={iconColor} />
              </span>
            )}
            {isDelete && (
              <span
                className="mr8 flex center jcenter delete-icon"
                onClick={deleteOption}
              >
                <SVGIcon name="Delete" color={iconColor} />
              </span>
            )}
          </>
        )}
        {option.editState && (
          <>
            <span className="mr8 flex center jcenter" onClick={editOption}>
              <SVGIcon name="SuccessCircle" color="#000" />
            </span>
            <span className="mr8 flex center jcenter" onClick={cancelEdit}>
              <SVGIcon name="RejectedCircle" color="#E72F23" />
            </span>
          </>
        )}
      </span>
    </OptionWrapper>
  );
};

export default EditAndDeleteOption;

export { OptionWrapper };
